export const config = {
  appID: '5710b22e-ae9a-44b0-9b16-6854138e9364',
  apiHost: 'https://api.directual.com',
  mobileWidth: 1000,
};
